 
export namespace DownloadsActions {
    export class LoadDownloads {
        static readonly type = '[Downloads] Load Downloads';
    }
}
